import { Compass } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase, DeviceFrame } from "../LibraryPrimitives";
import { TopHeader, BottomNav, DemoSidebar, Breadcrumbs, Tabs, SectionHeader } from "../nav";
import { SubjectCard } from "../cards";
import { Books } from "@phosphor-icons/react";

export function NavigationSection() {
  return (
    <SectionShell
      id="navigation"
      eyebrow="Navigation"
      eyebrowIcon={Compass}
      title="Finding your way, gently"
      description="Wayfinding is calm and predictable. Big tap areas, clear current-state and friendly labels mean a six-year-old never feels lost — and the same patterns scale up to a focused desktop workspace."
    >
      <div className="space-y-8">
        <div className="grid gap-8 lg:grid-cols-2">
          <Showcase title="Mobile · header + bottom nav" tone="muted">
            <DeviceFrame type="phone" label="Phone">
              <TopHeader />
              <div className="space-y-3 bg-background p-4">
                <SubjectCard subject="reading" size="sm" />
                <SubjectCard subject="maths" size="sm" />
              </div>
              <BottomNav active="home" />
            </DeviceFrame>
          </Showcase>

          <Showcase title="Desktop · sidebar" tone="muted">
            <DeviceFrame type="desktop" label="Desktop">
              <div className="flex min-h-[280px] bg-background">
                <DemoSidebar active="subjects" />
                <div className="flex-1 p-5">
                  <Breadcrumbs items={["Home", "Subjects", "Maths"]} />
                  <div className="mt-4 grid grid-cols-2 gap-3">
                    <SubjectCard subject="maths" size="sm" />
                    <SubjectCard subject="science" size="sm" />
                  </div>
                </div>
              </div>
            </DeviceFrame>
          </Showcase>
        </div>

        <div className="grid gap-5 md:grid-cols-2">
          <Showcase title="Breadcrumbs">
            <Breadcrumbs items={["Home", "English", "Spelling", "Lesson 4"]} />
          </Showcase>
          <Showcase title="Tabs">
            <Tabs
              tabs={[
                { id: "todo", label: "To do", content: "3 lessons waiting for you today." },
                { id: "progress", label: "Progress", content: "You're 72% through this week's goal." },
                { id: "rewards", label: "Rewards", content: "2 new badges to collect!" },
              ]}
            />
          </Showcase>
        </div>

        <Showcase title="Section header">
          <SectionHeader icon={Books} title="Continue learning" subtitle="Pick up where you left off" />
        </Showcase>
      </div>
    </SectionShell>
  );
}

export default NavigationSection;
